import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ModalAddContestComponent} from "../modal-add-contest/modal-add-contest.component";
import {ProjectsService} from "../../services/projects.service";
import {UserService} from "../../services/user.service";
import {ProjectPropertiesService} from "../../services/project-properties.service";

@Component({
  selector: 'app-modal-view-sent-survey-questionnaire',
  templateUrl: './modal-view-sent-survey-questionnaire.component.html',
  styleUrls: ['./modal-view-sent-survey-questionnaire.component.scss']
})
export class ModalViewSentSurveyQuestionnaireComponent implements OnInit {
    loading = false;

  constructor(
    public dialogRef: MatDialogRef<ModalAddContestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      surveyID: null,
      impersonateEmail: null,
    },
  ) {}

  ngOnInit() {
  }

  closeDialogue(event: any = null) {
    this.dialogRef.close(event);
  }
}
